import store from '@/store/store'

// Global identifiers derived from the authenticated session — the single source
// of truth for every service call. Components never pass these; services read
// them here at request time so the values are always current.
export const getGlobalParams = () => {
  const { operatorId, brandId, playerId, gameCode, gameMode, token } =
    store.getState().session.details
  // Currency is no longer a launch input; it comes from the init response and
  // lives in the wallet, so we read it back from there for every request.
  const { currencyCode: currency } = store.getState().wallet

  return { operatorId, brandId, playerId, gameCode, gameMode, token, currency }
}
